module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-steps', {
    staticStyle: {
      "margintop": "50px"
    },
    attrs: {
      "active": _vm.activeStep,
      "finish-status": "success",
      "align-center": ""
    }
  }, [_c('el-step', {
    attrs: {
      "title": "Datos Generales"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "Datos Impositivos"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "Datos Bancarios"
    }
  }), _vm._v(" "), (!_vm.isConfirmProvider) ? _c('el-step', {
    attrs: {
      "title": "Usuario"
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf5f132a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/MySteps.vue
// module id = 652
// module chunks = 1